import axios from 'axios'
import { ElMessage } from 'element-plus'
import { getToken } from '@/utils/auth'
import { getMerchantId } from '@/utils/auth-merchant'
import { useUserStore } from '@/stores/modules/user'
import { getMerchantDeviceSn } from '@/utils/merchant-device'
import router from '@/router'

// create an axios instance
const service = axios.create({
  baseURL: import.meta.env.VITE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 60000 // request timeout
})

// HTTP 请求拦截器
service.interceptors.request.use(
  (config) => {
    //  在发送 HTTP 请求前进行配置

    // 1.1 配置 Token
    const token = config.token || getToken()
    config.headers['Authorization'] = 'Bearer ' + token

    // 2.1 配置商户 ID
    config.headers['Y-Dashboard-Merchant-Id'] = getMerchantId()

    config.headers['Y-Pc-Sn'] = getMerchantDeviceSn()

    return config
  },
  (error) => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// HTTP 响应拦截
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */
  (response) => {
    const res = response.data

    if (res.code !== 200) {
      // 请求响应失败
      ElMessage.error({
        message: res.msg || 'Error',
        type: 'error',
        duration: 3 * 1000
      })

      return Promise.reject(new Error(res.msg || 'Error'))
    } else {
      return res
    }
  },
  (error) => {
    console.log('err: ' + error) // for debug
    console.log('response: ', error.response) // for debug
    if (error.response) {
      const res = error.response.data

      // 1401: 未登录
      if (res.code === 1401) {
        // const errMsg = res.message ? res.message : res.msg
        // ElMessage({
        //   message: errMsg,
        //   type: 'error',
        //   duration: 3 * 1000
        // })
        const userStore = useUserStore()
        userStore.logout() // 退出登录
        router.replace('/login')
      } else {
        const errMsg = res.message ? res.message : res.msg
        ElMessage({
          message: errMsg,
          type: 'error',
          duration: 3 * 1000
        })
      }
    }
    return Promise.reject(error)
  }
)

export default service
